import { Alert, Box, Button, Chip, Divider, Typography } from '@mui/material';
import {
    DateRange,
    PickersLayout,
    PickersLayoutProps,
    PickersShortcutsItem,
    PickerValidDate,
} from '@mui/x-date-pickers-pro';
import clsx from 'clsx';
import { format } from 'date-fns';

const DateRangePickerLayout = (
    props: PickersLayoutProps<DateRange<Date>, PickerValidDate, 'day'> & {
        shortcuts?: PickersShortcutsItem<DateRange<Date>>[];
    }
) => {
    const { value, slots, slotProps, alertMessage, buttons, shortcuts, ...rest } = props;

    const [start, end] = value ?? [];

    return (
        <Box className="w-min px-10 py-6">
            <Box
                className={clsx('w-fit', {
                    'px-[24px]': !shortcuts,
                    'mx-auto': shortcuts,
                })}
            >
                <Typography color="#666" fontSize={16} letterSpacing={0.15}>
                    SELECT DATE RANGE
                </Typography>
                <Typography variant="h4" className="text-[2rem]">
                    {start && end ? `${format(start, 'MMM d')} - ${format(end, 'MMM d')}` : '--'}
                </Typography>
            </Box>
            <PickersLayout
                {...rest}
                value={value}
                slots={{
                    ...slots,
                    shortcuts: ({ items = [], onChange }) => (
                        <Box display="flex" className="flex flex-col gap-4">
                            {items.map((item) => {
                                const itemValue = item.getValue({ isValid: () => true });

                                const isSelected =
                                    value?.[0]?.toDateString?.() === itemValue[0]?.toDateString?.() &&
                                    value?.[1]?.toDateString?.() === itemValue[1]?.toDateString?.();

                                return (
                                    <Chip
                                        key={item.label}
                                        label={item.label}
                                        className="w-fit"
                                        onClick={() => onChange(itemValue, 'set', item)}
                                        color={isSelected ? 'primary' : 'default'}
                                        variant={'filled'}
                                    />
                                );
                            })}
                        </Box>
                    ),
                }}
                slotProps={{
                    ...slotProps,
                    shortcuts: {
                        ...slotProps?.shortcuts,
                        sx: {
                            '& .MuiListItem-root': {
                                padding: 0,
                            },
                        },
                    },
                }}
                className="w-fit flex"
            />
            <Divider />
            {buttons && (
                <Box className="flex w-full justify-end gap-2">
                    <Button className="font-roboto tracking-wide text-sm" variant="text" onClick={rest.onClose}>
                        CANCEL
                    </Button>
                    <Button className="font-roboto tracking-wide text-sm" variant="text" onClick={rest.onClose}>
                        OK
                    </Button>
                </Box>
            )}
            {alertMessage && (
                <Box className="w-full break-words whitespace-break-spaces mt-4">
                    <Alert severity="info">{alertMessage}</Alert>
                </Box>
            )}
        </Box>
    );
};

export { DateRangePickerLayout };
